<template>
  <div class="vx-card org-card p-2">
    <!---->
    <div class="vx-card__collapsible-content vs-con-loading__container">
      <div class="vx-card__body">
        <div class="flex justify-between flex-wrap" style="align-items: center">
            <div>
                <div
                    class="con-vs-avatar ml-0 mb-6 block 80px"
                    style="width: 80px; height: 80px; background: rgb(195, 195, 195)"
                    >
                    <!---->
                    <div v-if="alexUserdata.userData.profilePictureUrl" class="con-img vs-avatar--con-img">
                        <img
                            :src="constants.s3Bucket +
                                '/editor/profile-pictures/' +
                                alexUserdata.userData.profilePictureUrl"
                            alt=""
                        />
                    </div>
                    <div v-else class="con-img vs-avatar--con-img">
                        <img
                            src="@/assets/images/icons/gender/default.png"
                            alt=""
                        />
                    </div>
                </div>
            </div>
            <div>
                <div v-if="alexUserdata.level" class="level--item p-3">
                    <h4>LEVEL {{alexUserdata.level.key}}</h4>
                </div>
            </div>
        </div>
        <div class="user-name--item items-left mb-base">
            <h4 class="mb-1">{{alexUserdata.userData.firstName}} {{alexUserdata.userData.lastName}}</h4>
            <span>{{alexUserdata.roleTitle}}</span>
        </div>
        <div class="user-details--item">
            <div>
                <feather-icon icon="MapPinIcon" :svgClasses="'w-5 h-5 mr-3'" style="color: #C5C8D2; float: left;"/>
                <span class="location">{{alexUserdata.currentLocation.label}}</span>
            </div><br>
            <div>
                <feather-icon icon="MailIcon" :svgClasses="'w-5 h-5 mr-3'" style="color: #C5C8D2; float: left;"/>
                <span class="location">{{alexUserdata.userData.email}}</span>
            </div><br>
        </div>
      </div>
      <div class="vx-card__footer">
        <div v-if="alexUserdata.status" class="flex justify-between flex-wrap">
            <vs-button class="message-btn" color="#F4F6F8">Message</vs-button>
            <vs-button class="message-btn" color="#F4F6F8">View Profile</vs-button>
        </div>
        <div v-else class="items-right">
            <div>
                <vs-button @click.stop="resendAlexInvitationLink()" type="filled" color="#F53855" icon="icon-send" icon-pack="feather"></vs-button>
                <!-- <vs-button type="filled" color="warning" icon="icon-edit" icon-pack="feather"></vs-button> -->
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants";
export default {
    props: ['alexUserdata'],
    data() {
        return {
            constants
        }
    },
    methods: {
        resendAlexInvitationLink() {
            const payload = {
                email: this.alexUserdata.userData.email,
                organizationId: '607aa2cce7a4360958e1538b',
                mailType: 'alex-invitation'
            };

            this.$store.dispatch('organization/resendAlexInvitationLink', payload).then(res => {
                this.$vs.notify({
                    title: "Alex invitation resent successfully",
                    text: "Alex invitation resent successfully",
                    iconPack: "feather",
                    icon: "icon-check-circle",
                    color: "success",
                    fixed: false,
                });
            })
            .catch(err => {
                this.$vs.notify({
                    title: "Failed to send Alex invitation",
                    text: "Failed to send Alex invitation",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    fixed: false,
                });
                throw err
            });
        }
    }
};
</script>

<style scoped>
.user-name--item h4 {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 27px;
    /* identical to box height */

    letter-spacing: -0.02em;
    text-transform: capitalize;

    color: #192A46;
}

.user-name--item span {
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */

    display: flex;
    align-items: center;

    color: #636175;
}
.level--item {
    background: rgba(36, 98, 238, 0.1);
    border-radius: 4px;
}

.level--item h4 {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    color: #2462EE;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 10px;
}

.user-details--item .location {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */
    display: flex;
    align-items: center;
    color: #A3A3A3;
}

.message-btn {
    background: #F4F6F8;
    border-radius: 6px;

    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    letter-spacing: -0.02em;

    color: #081343;
}
</style>